import { BuildClass, Do, guid, multiMap, timer } from '../../universal';
import { $, CryptoJS, React, _ } from '../lib';
import { IRIS } from './component-iris';
import { j2h } from './component-j2h';
import { J2rLoadingSpinner, j2r } from './component-react';
import { getNewFlyout, systemFlyout, to_page_unlock } from './flyouts-old';
import { moment } from './moment-wrapper';
import { Bindings } from './ui5';
export const uploadableInit = (obj) => new UploadWidget(obj);
class UploadWidget {
    queue;
    param;
    coverCl;
    startTime;
    $form;
    constructor(obj) {
        this.queue = [];
        this.param = this.normaliseData(obj);
        this.coverCl = 'file-drag-cover';
        this.addDropHandler();
    }
    normaliseData(obj) {
        if (obj == null) {
            obj = {};
        }
        if (obj.drop == null) {
            obj.drop = true;
        }
        if (obj.args == null) {
            obj.args = () => ({});
        }
        if (obj.showForm == null) {
            obj.showForm = true;
        }
        if (obj.maxSize == null) {
            obj.maxSize = 16;
        }
        if (obj.simultaneous == null) {
            obj.simultaneous = 2;
        }
        if (obj.pasteImage == null) {
            obj.pasteImage = false;
        }
        if (obj.$dragContainer == null) {
            obj.$dragContainer = $('body');
        }
        if (obj.onComplete == null) {
            obj.onComplete = _.noop;
        }
        if (obj.onFileComplete == null) {
            obj.onFileComplete = _.noop;
        }
        if (obj.formSize == null) {
            obj.formSize = [640, 500];
        }
        if (obj.url == null) {
            obj.url = '/upload/';
        }
        return obj;
    }
    addDropHandler() {
        if (!this.param.drop) {
            return;
        }
        const $dragContainer = this.param.$dragContainer;
        if (!$dragContainer) {
            return;
        }
        $dragContainer.css({ position: 'relative' });
        if (this.param.pasteImage) {
            $dragContainer.attr({ tabindex: 1 });
            $dragContainer.on('paste', (e) => {
                const clipboardData = e.originalEvent?.clipboardData;
                if (!clipboardData) {
                    return;
                }
                const { items } = clipboardData;
                const images = [];
                _.forEach(items, item => {
                    if (item.kind !== 'file') {
                        return;
                    }
                    const file = item.getAsFile();
                    if (file) {
                        images.push(file);
                    }
                });
                const firstImage = images[0];
                if (firstImage) {
                    this.cropAndUpload(firstImage);
                }
            });
        }
        $dragContainer.on('drag dragstart dragend dragover dragenter dragleave drop', (e) => {
            const dataTransfer = e.originalEvent?.dataTransfer;
            if (dataTransfer?.files != null) {
                e.preventDefault();
                e.stopPropagation();
            }
        });
        $dragContainer.on('dragenter dragover', (e) => {
            const dataTransfer = e.originalEvent?.dataTransfer;
            if (dataTransfer?.files == null) {
                return;
            }
            if ($dragContainer.children(`.${this.coverCl}`).length > 0) {
                return;
            }
            const $cover = $(j2h({ class: this.coverCl }));
            $dragContainer.append($cover);
            $cover.on('dragleave dragend drop', () => $dragContainer.children(`.${this.coverCl}`).remove());
        });
        $dragContainer.on('drop', (e) => {
            const dataTransfer = e.originalEvent?.dataTransfer;
            if (dataTransfer?.files) {
                _.forEach(dataTransfer.files, f => {
                    this.addToUploadQueue(f);
                });
            }
        });
    }
    openForm() {
        if ($('.frmUpload').length > 0) {
            return;
        }
        this.startTime = moment();
        this.$form = systemFlyout({
            title: 'Upload',
            size: this.param.formSize,
        });
        const $pane = this.$form.find('.floater_body').empty().addClass('frmUpload');
        $pane.css({ height: 'calc(100% - 44px)' });
        this.$form.find('.flyout_buttons').remove();
        $pane.append(j2h([
            {
                tag: 'input',
                class: 'filesInput',
                attr: {
                    name: 'file',
                    type: 'file',
                    multiple: null,
                },
                ev: {
                    change: (e) => {
                        const el = e.currentTarget;
                        if (el.files) {
                            _.forEach(el.files, f => {
                                this.addToUploadQueue(f);
                            });
                        }
                        $(el).wrap('<form>').closest('form').get(0)?.reset();
                        $(el).unwrap();
                    },
                },
            },
            { class: 'pnQueue' },
        ]));
        if (this.param.showForm === false) {
            return $pane.find('.filesInput').remove();
        }
    }
    addToUploadQueue(file) {
        $(`.${this.coverCl}`).remove();
        this.openForm();
        const F = new UploadFile({
            file,
            url: this.param.url || '/upload/',
            args: this.param.args?.() ?? {},
            maxSize: this.param.maxSize || 16,
            onRead: () => this.checkQueue(),
            onComplete: obj => {
                this.param.onFileComplete?.(obj);
                return this.checkQueue();
            },
        });
        $('.pnQueue').append(F.$el);
        this.queue.push(F);
    }
    checkQueue() {
        const ready_to_upload = [];
        let currently_uploading = 0;
        _.forEach(this.queue, F => {
            if (F.completed) {
                return;
            }
            if (!F.ready) {
                return;
            }
            if (F.uploading) {
                currently_uploading += 1;
            }
            else {
                ready_to_upload.push(F);
            }
        });
        if (currently_uploading === 0 && ready_to_upload.length === 0) {
            const timeTaken = this.startTime ? moment().diff(this.startTime) : 0;
            timer(800 - timeTaken, () => this.param.onComplete?.());
            return [];
        }
        let index = 0;
        return Do(() => {
            const result = [];
            while (currently_uploading < (this.param.simultaneous || 2) &&
                index < ready_to_upload.length) {
                const F = ready_to_upload[index];
                F?.upload();
                result.push((index += 1));
            }
            return result;
        });
    }
    cropAndUpload(img) {
        new ImageEdit(img, file => timer(600, () => {
            if (file && file instanceof File) {
                const newFile = new File([file], 'pasted.png', { type: file.type });
                this.addToUploadQueue(newFile);
            }
        }));
    }
}
export class UploadFile {
    $el;
    uploaderObject;
    file;
    onRead;
    onComplete;
    maxSize;
    args;
    url;
    filename;
    ready;
    uploading;
    completed;
    constructor(obj) {
        this.file = obj.file;
        this.onRead = obj.onRead ?? _.noop;
        this.onComplete = obj.onComplete ?? _.noop;
        this.maxSize = obj.maxSize;
        this.args = obj.args;
        this.url = obj.url;
        this.filename = this.file.name;
        [this.ready, this.uploading, this.completed] = [false, false, false];
        this.$el = this.makeProgressBlock();
        this.uploaderObject = uploadFileIris({
            fileObj: this.file,
            onProgress: (obj) => {
                if (isNaN(obj.percentage)) {
                    this.$el.find('.lbls .prog').text('Error!');
                    return;
                }
                this.$el.find('.progress').progressbar('value', obj.percentage);
            },
            onComplete: response => {
                this.$el.attr({ value: 100 });
                this.uploading = false;
                this.completed = true;
                this.onComplete(response);
            },
        });
        this.ready = true;
        timer(() => {
            this.onRead();
        });
    }
    makeProgressBlock() {
        const $el = $(j2h({
            class: 'queue-item',
            children: [
                {
                    class: 'lbls pending',
                    children: [
                        { tag: 'span', class: 'file', text: this.filename },
                        { tag: 'span', class: 'prog', text: '...' },
                        {
                            tag: 'span',
                            class: 'size',
                            text: Do(() => {
                                const kb = this.file.size / 1024;
                                return `${kb.toFixed(1)} KB`;
                            }),
                        },
                    ],
                },
                { class: 'progress' },
            ],
        }));
        const $prog = $el.find('.progress');
        $prog.progressbar({
            change: () => $el.find('.prog').text(Do(() => {
                const val = +$prog.progressbar('value');
                if (val !== 100) {
                    $el.find('.lbls').removeClass('done');
                    $el.removeClass('done');
                }
                return `${val.toFixed(1)}%`;
            })),
            complete: () => {
                $el.find('.lbls').addClass('done');
                $el.addClass('done');
                return $el.find('.prog').text('100%');
            },
        });
        return $el;
    }
    async upload() {
        this.uploading = true;
        return this.uploaderObject();
    }
}
class ImageEdit {
    file;
    callback;
    img;
    b64;
    dimensions;
    multiplier;
    scaledDimensions;
    $F;
    $selector;
    constructor(img, cb) {
        Bindings(this, [this.updateCropPreview]);
        this.file = img;
        this.callback = cb;
        this.img = new Image();
        this.b64 = null;
        this.dimensions = [0, 0];
        this.multiplier = 1;
        this.imgRead();
    }
    imgRead() {
        const reader = new FileReader();
        reader.onload = e => {
            this.b64 = e.target?.result || null;
            this.img.onload = () => {
                this.dimensions = [this.img.width, this.img.height];
                timer(() => {
                    this.showWidget();
                });
            };
            if (typeof this.b64 === 'string') {
                this.img.src = this.b64;
            }
        };
        reader.readAsDataURL(this.file);
    }
    updateMultiplier(w, h) {
        const [max_w, max_h] = [
            (window.innerWidth || 800) - 50,
            (window.innerHeight || 600) - 50,
        ];
        this.multiplier = Math.min(1, max_w / w, max_h / h);
        this.scaledDimensions = [w * this.multiplier, h * this.multiplier];
    }
    buildFlyout() {
        const dimensions = this.scaledDimensions || [400, 300];
        const $flyout = getNewFlyout('', dimensions);
        this.$F = $flyout.closest('.to_floater');
        this.$F.addClass('frmImageEdit');
        this.$F.children().remove();
    }
    showWidget() {
        const [w, h] = this.dimensions;
        if (!w || !h) {
            console.error('Invalid image dimensions', w, h);
            return;
        }
        this.updateMultiplier(w, h);
        const [sw, sh] = this.scaledDimensions;
        this.buildFlyout();
        this.$F.empty();
        this.$F.css({ padding: 0 });
        this.$F.append(j2h({
            tag: 'img',
            attr: {
                src: this.b64,
                style: `width:${sw}px;height:${sh}px;`,
            },
        }));
        this.$selector = $(j2h({
            class: 'cropSelector',
            attr: { tabindex: 1 },
        }));
        this.$selector.draggable({
            containment: 'parent',
            drag: this.updateCropPreview,
        });
        this.$selector.resizable({
            containment: 'parent',
            handles: 'n, e, s, w, ne, se, sw, nw',
            resize: this.updateCropPreview,
        });
        this.$F.append(this.$selector);
        _.times(4, () => this.$F.append(j2h({ class: 'black' })));
        timer(600, () => {
            this.updateCropPreview();
        });
        this.$selector.focus().on('keypress', e => {
            if (e.which === 13) {
                this.crop();
            }
        });
    }
    updateCropPreview() {
        const [frame, select] = this.getSelectionFrameGeos();
        const margins = {
            north: select.y - frame.y,
            east: frame.x + frame.w - (select.x + select.w),
            south: frame.y + frame.h - (select.y + select.h),
            west: select.x - frame.x,
        };
        const lhs = {
            x: 0,
            y: 0,
            w: margins.west,
            h: frame.h,
        };
        const rhs = {
            x: margins.west + select.w,
            y: 0,
            w: margins.east,
            h: frame.h,
        };
        const ths = {
            x: margins.west,
            y: 0,
            w: select.w,
            h: margins.north,
        };
        const bhs = {
            x: margins.west,
            y: margins.north + select.h,
            w: select.w,
            h: margins.south,
        };
        const getStrip = (geo) => [
            `left: ${geo.x}px`,
            `top: ${geo.y}px`,
            `width: ${geo.w}px`,
            `height: ${geo.h}px`,
        ].join(';');
        const $els = this.$F.children('.black');
        [lhs, rhs, ths, bhs].forEach((geo, index) => $els.eq(index).attr({ style: getStrip(geo) }));
    }
    getSelectionFrameGeos() {
        const FPOS = this.$F.position();
        const frame = {
            x: FPOS.left || 0,
            y: FPOS.top || 0,
            w: this.$F.width() || 0,
            h: this.$F.height() || 0,
        };
        const SPOS = this.$selector.position();
        const select = {
            x: (SPOS.left || 0) + frame.x,
            y: (SPOS.top || 0) + frame.y,
            w: this.$selector.width() || 0,
            h: this.$selector.height() || 0,
        };
        return [frame, select];
    }
    crop() {
        const invMul = 1 / this.multiplier;
        const [frame, select] = this.getSelectionFrameGeos();
        const C = {
            x: Math.round((select.x - frame.x) * invMul),
            y: Math.round((select.y - frame.y) * invMul),
            w: Math.round(select.w * invMul),
            h: Math.round(select.h * invMul),
        };
        const canvas = j2h({ tag: 'canvas' });
        canvas.width = C.w;
        canvas.height = C.h;
        const context = canvas.getContext('2d');
        if (context) {
            context.drawImage(this.img, C.x, C.y, C.w, C.h, 0, 0, C.w, C.h);
            canvas.toBlob(blob => {
                to_page_unlock();
                this.callback(blob);
            });
        }
        else {
            this.callback(null);
        }
    }
}
export const uploadFileIris = (input) => {
    const PACKET_SIZE = 256 * 1024;
    const PARALLEL_COUNT = 4;
    const fileID = guid().replace(/-/g, '').substring(0, 8);
    let isComplete = false;
    let expectedChecksumLocal = '';
    const onProgressInner = (obj) => {
        input.onProgress?.({
            ...obj,
            file: input.fileObj,
            percentage: isComplete ? 100 : obj.percentage,
        });
    };
    const onCompleteInner = (checksum) => {
        if (expectedChecksumLocal && checksum && expectedChecksumLocal !== checksum) {
            input.onError?.(`Checksum mismatch – upload corrupted (expected ${expectedChecksumLocal}, got ${checksum})`);
            return;
        }
        isComplete = true;
        input.onComplete?.({
            file: input.fileObj,
            checksum: checksum,
        });
    };
    const getChecksumLocal = new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onerror = e => {
            reject(e);
        };
        reader.onloadend = () => {
            const arrayBuffer = reader.result;
            const uint8Array = new Uint8Array(arrayBuffer);
            const wordArray = CryptoJS.lib.WordArray.create(uint8Array);
            const hash = CryptoJS.MD5(wordArray);
            resolve(hash.toString());
        };
        reader.readAsArrayBuffer(input.fileObj);
    });
    const getBase64Contents = async () => new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => {
            const result = reader.result;
            if (typeof result === 'string') {
                const parts = result.split(',');
                resolve(parts[1] || '');
            }
            else {
                reject(new Error('Failed to read file as base64'));
            }
        };
        reader.onerror = (e) => {
            reject(e);
        };
        reader.readAsDataURL(input.fileObj);
    });
    const getUploadablePackets = async (checksum) => {
        if (input.ignoreChecksums?.includes(checksum)) {
            onProgressInner({
                percentage: 100,
            });
            onCompleteInner(checksum);
            return [];
        }
        const b64String = await getBase64Contents();
        if (!b64String) {
            onProgressInner({
                percentage: 100,
            });
            onCompleteInner(null);
            return [];
        }
        const starts = _.range(0, b64String.length, PACKET_SIZE);
        const packets = starts.map(start => {
            const end = Math.min(start + PACKET_SIZE, b64String.length);
            return b64String.substring(start, end);
        });
        return packets.map((blob, index) => ({
            fileID,
            pktIndex: index + 1,
            pktCount: packets.length,
            contentType: input.fileObj.type,
            data: blob,
        }));
    };
    const sendPacket = async (packet, tries = 0) => new Promise((resolve, reject) => {
        if (tries > 3) {
            reject('Failed to send packet');
            return;
        }
        IRIS.Send({
            data: {
                progID: 0,
                funcID: 26,
                fileID: packet.fileID,
                pktIndex: packet.pktIndex,
                pktCount: packet.pktCount,
                contentType: packet.contentType,
                __data: packet.data,
            },
            no: data => {
                console.error(data);
                sendPacket(packet, tries + 1);
            },
            yes: data => {
                if (data.uploadFinished) {
                    data.uploadProgress = 100;
                }
                try {
                    onProgressInner({
                        percentage: data.uploadProgress,
                        found: data.packetsFound,
                        needed: data.packetsNeeded,
                    });
                }
                catch (err) {
                    console.error('Failed to update progress', err);
                }
                if (data.uploadFinished) {
                    onCompleteInner(data.fileHash);
                }
                resolve(data);
            },
        });
    });
    const uploadFile = async (packets, tries = 0) => {
        if (tries > 3) {
            throw new Error('Failed to upload file');
        }
        const response = await multiMap(packets, PARALLEL_COUNT, async (packet) => {
            await sendPacket(packet);
        });
        if (response.failed > 0) {
            console.error('Failed ');
            return uploadFile(packets, tries + 1);
        }
        const errs = _(response.items)
            .map(x => x.err)
            .compact()
            .join(' | ');
        if (errs) {
            console.error('Failed to upload file', errs);
            return uploadFile(packets, tries + 1);
        }
        return;
    };
    return async () => {
        let checksum = '';
        try {
            checksum = await getChecksumLocal;
            expectedChecksumLocal = checksum;
            input.onStart?.(checksum);
            const packets = await getUploadablePackets(checksum);
            await uploadFile(packets);
        }
        catch (err) {
            const e = err instanceof Error ? err : new Error(String(err));
            input.onError?.(e.message);
            console.error('Failed to upload file', { checksum, e });
        }
    };
};
export const uploadFileGuid = (input) => {
    const uploader = uploadFileIris({
        fileObj: input.fileObj,
        onStart: () => {
            input.onStart?.();
        },
        onError: error => {
            input.onError?.(error);
        },
        onComplete: resp => {
            input.onComplete?.({
                file: resp.file,
                guid: resp.checksum ?? guid(),
            });
        },
    });
    return async () => {
        await uploader();
    };
};
export class UploadFileContainer extends React.Component {
    rootNode;
    uploaders;
    inputRef;
    constructor(props) {
        super(props);
        Bindings(this, [
            this._onClick,
            this._onFileSelected,
            this._onDragEnter,
            this._onDragLeave,
            this._onDragOver,
            this._onDrop,
            this._onPaste,
        ]);
        this.rootNode = React.createRef();
        this.inputRef = React.createRef();
        this.state = {
            isHovering: 0,
            isUploading: false,
            isRegistering: false,
            progress: [],
        };
    }
    componentDidMount() {
        const el = this.rootNode.current;
        if (el) {
            el.addEventListener('mouseup', this._onDragLeave);
            el.addEventListener('dragenter', this._onDragEnter);
            el.addEventListener('dragover', this._onDragOver);
            el.addEventListener('dragleave', this._onDragLeave);
            el.addEventListener('drop', this._onDrop);
            el.addEventListener('paste', this._onPaste);
            el.addEventListener('click', this._onClick);
        }
    }
    render() {
        const children = Do(() => {
            if (this.state.isUploading) {
                return [
                    {
                        cl: 'uploading-progress',
                        key: 'uploading-progress',
                        children: [
                            {
                                key: 'msg',
                                cl: 'msg',
                                text: Do(() => {
                                    if (this.state.isRegistering) {
                                        return 'Registering...';
                                    }
                                    else if (this.state.progress.length > 0) {
                                        const avg = _.sum(this.state.progress) /
                                            this.state.progress.length;
                                        return `${Math.round(avg)}%`;
                                    }
                                    return 'Starting upload...';
                                }),
                            },
                            {
                                tag: J2rLoadingSpinner,
                                key: 'spinner',
                                size: 'large',
                            },
                        ],
                    },
                ];
            }
            return _.flatten([
                {
                    key: 'mc',
                    cl: 'mouse-catcher',
                    children: [
                        {
                            key: 'mc-inner',
                            cl: BuildClass({
                                'mouse-catcher-inner': true,
                                hovering: this.state.isHovering > 0,
                            }),
                        },
                    ],
                },
                this.buildCustomContent(),
            ]);
        });
        return j2r({
            ref: this.rootNode,
            cl: BuildClass({
                [this.props.cl || '']: true,
                'drag-drop-container': true,
            }),
            style: this.props.height ? { height: `${this.props.height}px` } : {},
            children: children,
        });
    }
    buildCustomContent() {
        if (this.props.inner != null) {
            return this.props.inner;
        }
        return [
            {
                cl: BuildClass({
                    'upload-component-stub': true,
                    hovering: Boolean(this.state.isHovering),
                }),
                key: 'stub-upload-indicator',
                children: [
                    {
                        tag: 'input',
                        key: 'file',
                        type: 'file',
                        id: 'fileUpload',
                        style: { display: 'none' },
                        ref: this.inputRef,
                        onChange: this._onFileSelected,
                    },
                    {
                        tag: 'span',
                        key: 'text',
                        text: Do(() => {
                            if (this.state.isHovering) {
                                return this.props.dropText ?? 'Drop to upload';
                            }
                            return this.props.dragText ?? 'Click or drag files here';
                        }),
                    },
                    {
                        tag: 'span',
                        key: 'subtitle',
                        cl: 'subtitle',
                        text: this.props.subtitle ?? '',
                    },
                ],
            },
        ];
    }
    _onClick(_e) {
        this.inputRef.current?.click();
    }
    _onFileSelected(e) {
        const files = e.target.files;
        if (files != null) {
            timer(() => {
                const fileList = [];
                for (let i = 0; i < files.length; i++) {
                    const file = files.item(i);
                    if (file) {
                        fileList.push(file);
                    }
                }
                this.uploadFiles(fileList);
            });
        }
        return false;
    }
    _onDragEnter(e) {
        this.setState({ isHovering: Math.max(0, this.state.isHovering + 1) });
        e.stopPropagation();
        e.preventDefault();
        return false;
    }
    _onDragOver(e) {
        e.preventDefault();
        e.stopPropagation();
        return false;
    }
    _onDragLeave(e) {
        this.setState({ isHovering: Math.max(0, this.state.isHovering - 1) });
        e.stopPropagation();
        e.preventDefault();
        return false;
    }
    _onDrop(e) {
        e.preventDefault();
        this.setState({ isHovering: 0 });
        const dataTransfer = e?.dataTransfer;
        const files = dataTransfer?.files;
        if (files != null) {
            timer(() => {
                const fileList = [];
                for (let i = 0; i < files.length; i++) {
                    const file = files.item(i);
                    if (file) {
                        fileList.push(file);
                    }
                }
                this.uploadFiles(fileList);
            });
        }
        return false;
    }
    _onPaste(e) {
        const clipboardData = e?.clipboardData;
        if (!clipboardData) {
            return;
        }
        const images = [];
        _.forEach(clipboardData.items, item => {
            if (item.kind !== 'file') {
                return;
            }
            const file = item.getAsFile();
            if (file) {
                images.push(file);
            }
        });
        const firstImage = images[0];
        if (firstImage) {
            this.cropAndUpload(firstImage);
        }
    }
    cropAndUpload(img) {
        new ImageEdit(img, file => timer(600, () => {
            if (file && file instanceof File) {
                const newFile = new File([file], 'pasted.png', { type: file.type });
                this.uploadFiles([newFile]);
            }
        }));
    }
    uploadFiles(files) {
        if (this.state.isUploading || files == null || !files.length) {
            return;
        }
        this.setState({ progress: _.map(files, () => null) });
        const responses = _.map(files, x => ({
            file: x,
            checksum: null,
        }));
        let required_to_finish = files.length;
        this.uploaders = files.map((file, index) => uploadFileIris({
            fileObj: file,
            onProgress: e => {
                this.setState(s => ({
                    progress: s.progress.map((p, i) => {
                        if (i === index) {
                            return e.percentage;
                        }
                        return p;
                    }),
                }));
            },
            onComplete: e => {
                console.log(`Completed: ${e.checksum || 'no checksum'}`);
                responses[index] = {
                    file: e.file,
                    checksum: e.checksum || null,
                };
                required_to_finish -= 1;
                if (required_to_finish === 0) {
                    const cb = () => {
                        this.setState({
                            isUploading: false,
                            isRegistering: false,
                        });
                    };
                    this.setState({ isRegistering: true });
                    const validResponses = responses.filter((r) => r.checksum != null);
                    this.props.onUpload(validResponses, cb);
                }
            },
        }));
        this.setState({ isUploading: true });
        this.uploaders.forEach(async (x) => x());
    }
}
//# sourceMappingURL=component-upload.js.map